import { render, staticRenderFns } from "./CallerIdList.vue?vue&type=template&id=8647a3ee&"
import script from "./CallerIdList.vue?vue&type=script&lang=js&"
export * from "./CallerIdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports